import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "studentId",
    "correctionsCount",
    "subjectCallsCount",
    "strategyCallsCount",
    "studentLink",
    "studentLinkContainer",
    "registeredStudentField",
    "preClientField"
  ];

  connect() {
    // Store original values on page load
    this.originalStudentId = this.studentIdTarget.value;
    const preClientInput = this.preClientFieldTarget.querySelector('input[name="client_happiness[student_name]"]');
    this.originalStudentName = preClientInput ? preClientInput.value : '';
    
    // If student is already selected on page load (edit form), fetch stats
    if (this.studentIdTarget.value) {
      this.fetchStudentStats();
      this.updateStudentLink();
    }
  }

  // Toggle between registered student and pre-client fields
  toggleStudentType(event) {
    const isRegistered = event.target.value === 'registered';
    
    if (isRegistered) {
      this.registeredStudentFieldTarget.classList.remove('hidden');
      this.preClientFieldTarget.classList.add('hidden');
      
      // Clear the pre-client name field so it doesn't get submitted
      const preClientInput = this.preClientFieldTarget.querySelector('input[name="client_happiness[student_name]"]');
      if (preClientInput) {
        preClientInput.value = '';
      }
      
      // Restore original student_id if it exists
      if (this.originalStudentId) {
        this.studentIdTarget.value = this.originalStudentId;
        this.fetchStudentStats();
        this.updateStudentLink();
      }
    } else {
      this.registeredStudentFieldTarget.classList.add('hidden');
      this.preClientFieldTarget.classList.remove('hidden');
      
      // Clear the student_id field so it doesn't get submitted
      this.studentIdTarget.value = '';
      
      // Restore original student_name if it exists
      const preClientInput = this.preClientFieldTarget.querySelector('input[name="client_happiness[student_name]"]');
      if (preClientInput && this.originalStudentName) {
        preClientInput.value = this.originalStudentName;
      }
      
      this.clearStats();
      if (this.hasStudentLinkContainerTarget) {
        this.studentLinkContainerTarget.classList.add('hidden');
      }
    }
  }

  // Called when student selection changes
  studentChanged() {
    this.fetchStudentStats();
    this.updateStudentLink();
  }

  updateStudentLink() {
    const studentId = this.studentIdTarget.value;
    
    if (!studentId) {
      // Hide the link container if no student selected
      if (this.hasStudentLinkContainerTarget) {
        this.studentLinkContainerTarget.classList.add('hidden');
      }
      return;
    }

    // Show and update the link
    if (this.hasStudentLinkContainerTarget) {
      this.studentLinkContainerTarget.classList.remove('hidden');
      
      // Update the href to point to the selected student's calendar
      if (this.hasStudentLinkTarget) {
        this.studentLinkTarget.href = `/pupils/${studentId}/cal_events?selected=future`;
      }
    }
  }

  async fetchStudentStats() {
    const studentId = this.studentIdTarget.value;
    
    if (!studentId) {
      this.clearStats();
      return;
    }

    try {
      const response = await fetch(`/api/students/${studentId}/stats`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch student stats');
      }

      const data = await response.json();
      
      this.correctionsCountTarget.textContent = data.corrections_count || 0;
      this.subjectCallsCountTarget.textContent = data.subject_calls_count || 0;
      this.strategyCallsCountTarget.textContent = data.strategy_calls_count || 0;
    } catch (error) {
      console.error('Error fetching student stats:', error);
      this.clearStats();
    }
  }

  clearStats() {
    if (this.hasCorrectionsCountTarget) this.correctionsCountTarget.textContent = '-';
    if (this.hasSubjectCallsCountTarget) this.subjectCallsCountTarget.textContent = '-';
    if (this.hasStrategyCallsCountTarget) this.strategyCallsCountTarget.textContent = '-';
  }
}
